import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { Constants } from 'src/app/app.constants';
import { AlertService } from 'src/app/core/alert.service';
import { AuthService } from 'src/app/core/auth.service';
import { DialogService } from 'src/app/core/dialog.service';
import { LoadingService } from 'src/app/core/loading.service';
import { TranslatorService } from 'src/app/core/translator.service';
import { UtilityService } from 'src/app/core/utility.service';
import { BaseFormComponent } from 'src/app/shared/base/base-form.component';
import { BaseService } from 'src/app/shared/base/base.service';
import { ExceptionLog, ExceptionLogType, StackTrace } from '../exception-logs.models';
import { ExceptionLogsService } from '../exception-logs.service';

@Component({
  selector: 'app-exception-logs-form',
  templateUrl: './exception-logs-form.component.html',
  styleUrls: ['./exception-logs-form.component.scss']
})
export class ExceptionLogsFormComponent extends BaseFormComponent implements OnInit {
  @ViewChild('table', { static: false }) table: DxDataGridComponent;
  public tabs: string[] = ['STACK_TRACE'];
  public stackTrace: StackTrace[] = [];

  constructor(
    private translateService: TranslateService,
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService,
    private exceptionLogService: ExceptionLogsService
  ) {
    super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService);
  }

  ngOnInit() {
    this.authorities.init('EXC_LOG', 'EXC_LOG', 'EXC_LOG', 'EXC_LOG');
    this.url = `${Constants.contextPath}/exception-logs`;
    this.prepareFormData(null, (result: ExceptionLog) => {
      return this.modifyResult(result)
    });
  }

  changeToIgnore(e) {
    this.exceptionLogService.changeStatus(this.id, ExceptionLogType.IGNORE, () => {
      this.baseService.getById(this.url, this.id, (data: ExceptionLog) => { 
        this.formData = this.modifyResult(data);
        this.alertService.success('SHARED.SAVE_SUCCESS');
      })
    })
  }

  changeToInProgress(e) {
    this.exceptionLogService.changeStatus(this.id, ExceptionLogType.IN_PROGRESS, () => {
      this.baseService.getById(this.url, this.id, (data: ExceptionLog) => { 
        this.formData = this.modifyResult(data);
        this.alertService.success('SHARED.SAVE_SUCCESS');
      })
    })
  }

  changeToResolved(e) {
    this.exceptionLogService.changeStatus(this.id, ExceptionLogType.RESOLVED, () => {
      this.baseService.getById(this.url, this.id, (data: ExceptionLog) => { 
        this.formData = this.modifyResult(data);
        this.alertService.success('SHARED.SAVE_SUCCESS');
      })
    })
  }

  private modifyResult(result: ExceptionLog) {
    this.stackTrace = [];
    result.requestParams = "";
    result.type = this.translateService.instant(`ENUMS.EXCEPTION-LOGS.${result.type}`)
    if (result.queryParameters) result.queryParameters.forEach(element => result.requestParams += `${element}\n`);
    if (result.stackTrace) this.stackTrace = result.stackTrace;
    return result;
  }

  viewUser() {
    this.router.navigateByUrl(`/users/${this.formData.loggedUser}`);
  }

}
